import { Component, input, OnInit, output } from '@angular/core';
import { StringLocalized } from '../../../models/shared/string-localized';

@Component({
  selector: 'app-option-selector',
  templateUrl: './option-selector.component.html',
  styleUrls: ['./option-selector.component.scss'],
  standalone: false,
})
export class OptionSelectorComponent implements OnInit {
  isSelected = input.required<boolean>();

  item = input.required<any>();
  icon = input<string>();

  name = input<StringLocalized | undefined>();
  nameString = input<string | undefined>();

  description = input<StringLocalized | undefined>();
  descriptionString = input<string | undefined>();
  

  small = input<boolean>(false);

  isCheckbox = input<boolean>(false);

  isDisabled = input<boolean>(false);

  constructor() {}

  ngOnInit() {}
}
